export default "__VITE_ASSET__BfAaMzsG__"